import { MessageCircle, MapPin, ArrowRight, ShieldCheck } from "lucide-react";
import { WHATSAPP_URL } from "../i18n";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_autocare-ngv/artifacts/8073qafm_ChatGPT%20Image%20May%206%2C%202026%2C%2004_20_40%20AM.png";

export const Hero = ({ t }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-neutral-50 pt-28"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 pb-20 pt-10 md:px-12 lg:grid-cols-12 lg:gap-16 lg:pb-32 lg:pt-20">
        <div className="lg:col-span-7">
          <div className="mb-6 inline-flex items-center gap-2 border border-neutral-300 bg-white px-3 py-1.5">
            <span className="h-1.5 w-1.5 animate-pulse bg-green-600" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-700">
              {t.hero.tagline}
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display text-4xl font-black leading-[1.02] tracking-tighter text-neutral-950 sm:text-5xl lg:text-6xl"
          >
            {t.hero.headline}
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-neutral-600 md:text-lg">
            {t.hero.sub}
          </p>

          <div className="mt-8 flex items-center gap-2 text-sm text-neutral-700">
            <MapPin size={16} className="text-green-600" />
            <span className="font-medium">{t.hero.location}</span>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              className="group inline-flex items-center gap-3 bg-green-600 px-7 py-4 text-sm font-semibold text-white transition-all duration-200 hover:bg-green-700 hover:shadow-lg"
            >
              <MessageCircle size={18} />
              {t.hero.cta}
              <ArrowRight
                size={16}
                className="transition-transform duration-200 group-hover:translate-x-1"
              />
            </a>

            <a
              href="#services"
              data-testid="hero-services-btn"
              className="inline-flex items-center gap-2 border border-neutral-900 bg-white px-7 py-4 text-sm font-semibold text-neutral-900 transition-colors duration-200 hover:bg-neutral-900 hover:text-white"
            >
              {t.hero.secondary}
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-neutral-200 pt-8 sm:gap-10">
            <Stat k="500+" v="Installations" />
            <Stat k="100%" v="Leak-tested" />
            <Stat k="1 day" v="Avg. fitment" />
          </div>
        </div>

        <div className="relative lg:col-span-5">
          <div className="relative overflow-hidden border border-neutral-200 bg-neutral-900">
            <img
              src={HERO_IMG}
              alt="CNG AutoCare technician handing over a completed CNG conversion"
              className="aspect-square h-full w-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent p-6">
              <div className="flex items-center gap-3 text-white">
                <ShieldCheck size={20} className="text-green-400" />
                <div>
                  <div className="text-xs uppercase tracking-[0.2em] text-green-400">
                    Certified
                  </div>
                  <div className="text-sm font-semibold">
                    Pressure & Leak Tested
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute -bottom-6 -left-6 hidden border border-neutral-900 bg-neutral-950 p-5 text-white sm:block">
            <div className="text-[10px] uppercase tracking-[0.25em] text-green-400">
              Save up to
            </div>
            <div className="mt-1 font-display text-4xl font-black tracking-tighter">
              60%
            </div>
            <div className="mt-1 text-xs text-neutral-400">on fuel costs</div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ k, v }) => (
  <div>
    <div className="font-display text-2xl font-black tracking-tighter text-neutral-950 sm:text-3xl">
      {k}
    </div>
    <div className="mt-1 text-xs uppercase tracking-[0.15em] text-neutral-500">
      {v}
    </div>
  </div>
);
